import {leaveChannel, subscribeToPrivateChannelEvents} from "@/utils/Sockets";

export default {
    props: {},
    data(){
        return {
            event: null,
            documents: []
        }
    },
    beforeDestroy(){
        const vm = this
        if(!vm.event) return
        leaveChannel(`appointment.${vm.event.id}`)
    },
    methods:{
        openDoc(path){
            window.open(path,"_blank");
        },
        connectDocumentsSocket(event){

            if(!event) return

            const vm = this
            vm.event = event
            vm.documents = event.appointment_documents || []

            subscribeToPrivateChannelEvents(`appointment.${event.id}`, {
                'AppointmentDocumentUploaded': vm.onDocumentUploaded,
                'AppointmentDocumentDeleted': vm.onDocumentDeleted,
            })
        },
        onDocumentDeleted({document}){
            const vm = this
            console.debug('document deleted:', document)
            const index = vm.documents.findIndex(doc => doc.id === document.id)
            if(index !== -1){
                vm.documents.splice(index, 1)
            }
        },
        onDocumentUploaded({document}){
            var vm = this
            console.debug('document uploaded:', document)
            if(document.user.id !== vm.currentUser.id){
                vm.$store.commit('showSnackBar', {
                    text: 'Se ha cargado un nuevo documento',
                    color: 'success'
                })
            }
            const index = vm.documents.findIndex(doc => doc.id === document.id)
            if(index === -1){
                vm.documents.push(document)
            }
        },
    },
    watch: {
    }
}
